import { render } from "./CommonQuestion.vue?vue&type=template&id=626b58c2"
import script from "./CommonQuestion.vue?vue&type=script&lang=js"
export * from "./CommonQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__